import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useState } from "react";
import Brand from "./Brand";
import { apiFetch } from "../services/api";
import { User } from "../types";
const links = [
  ["/dashboard", "◈", "Overview"],
  ["/search", "⌕", "Find leads"],
  ["/my-leads", "▤", "My lists"],
  ["/saved-searches", "☆", "Saved searches"],
  ["/downloads", "↓", "Downloads"],
  ["/affiliate", "↗", "Affiliate dashboard"],
  ["/billing", "▣", "Billing"],
  ["/help", "?", "Help & support"],
];
export default function WorkspaceShell({
  user,
  onLogout,
}: {
  user: User;
  onLogout: () => void;
}) {
  const [open, setOpen] = useState(false),
    [error, setError] = useState("");
  const navigate = useNavigate();
  const logout = async () => {
    try {
      const r = await apiFetch("/api/auth/logout", { method: "POST" });
      if (!r.ok) throw new Error();
      onLogout();
      navigate("/login");
    } catch {
      setError("Unable to sign out. Try again.");
    }
  };
  return (
    <div className="workspace">
      <aside className={`workspace-sidebar ${open ? "open" : ""}`}>
        <div className="sidebar-brand">
          <Brand />
          <button
            className="mobile-close"
            onClick={() => setOpen(false)}
            aria-label="Close navigation"
          >
            ×
          </button>
        </div>
        <p className="sidebar-label">YOUR WORKSPACE</p>
        <nav>
          {links.map(([path, icon, label]) => (
            <NavLink key={path} to={path} onClick={() => setOpen(false)}>
              <span aria-hidden="true">{icon}</span>
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="sidebar-plan">
          <span className="eyebrow">YOUR PLAN</span>
          <strong>
            {user.plan === "yearly"
              ? "Annual"
              : user.plan === "monthly"
                ? "Monthly"
                : "Explore ReachAtlas"}
          </strong>
          <p>{user.credits.toLocaleString()} credits available</p>
          <NavLink to="/billing">Manage subscription ↗</NavLink>
        </div>
        <div className="sidebar-account">
          <span className="avatar">{user.email[0].toUpperCase()}</span>
          <span className="account-email">{user.email}</span>
          <button onClick={() => void logout()} aria-label="Sign out">
            ↪
          </button>
        </div>
        {error && <p role="alert">{error}</p>}
      </aside>
      {open && (
        <button
          className="sidebar-scrim"
          onClick={() => setOpen(false)}
          aria-label="Close menu"
        />
      )}
      <div className="workspace-body">
        <header className="workspace-topbar">
          <button
            className="nav-toggle"
            onClick={() => setOpen(true)}
            aria-label="Open navigation"
          >
            ☰
          </button>
          <span className="workspace-label">
            Your next opportunity starts here.
          </span>
          <NavLink className="credit-pill" to="/billing">
            <span>✦</span> {user.credits.toLocaleString()} credits
          </NavLink>
          <span className="avatar small">{user.email[0].toUpperCase()}</span>
        </header>
        <main className="workspace-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
